import { render, staticRenderFns } from "./CaseHeader.vue?vue&type=template&id=602aa59e"
import script from "./CaseHeader.vue?vue&type=script&lang=js"
export * from "./CaseHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports